var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "button", class: { "button--disabled": _vm.isLoading } },
    [
      !_vm.isLoading
        ? _vm._t("default")
        : _c("span", { staticClass: "spinner" }, [
            _vm._v(_vm._s(_vm.loadingLabel || "Loading"))
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }